import { type PropsWithChildren, useState } from "react";
import { createStore } from "zustand";

import { TrackingContext, type TrackingState } from "./TrackingContext";
import { TrackingStore } from "./TrackingStore";

export function TrackingProvider(props: PropsWithChildren) {
  const [store] = useState(() => createStore<TrackingState>(TrackingStore));

  return <TrackingContext.Provider value={store}>{props.children}</TrackingContext.Provider>;
}
